import { useLazyQuery, useQuery } from '@apollo/client';
import { MeData } from 'graphQL/Auth/types';
import { useUserInformation } from 'graphQL/Zustand/useUserInformation';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { ItemType, OrderConnection, OrderState } from 'types/api';
import { errorHandler } from 'utils/ErrorHandler';
import { GET_ORDERS } from '..';
import { OrderFilterInput } from '../types';

export function useQueryGetOrders() {
  const location = useLocation();

  const selectedOrderId = localStorage.getItem('orderId'); // 예약 내역에서 넘어왔을때 필요한 값
  const selectedScheduleIds = localStorage.getItem('scheduleIds'); // 예약 내역에서 넘어왔을때 필요한 값

  const myInfo: MeData = useUserInformation(state => state.userInfo);

  const [getOrderItems, { data, loading, refetch }] = useLazyQuery<{
    order: { orders: OrderConnection };
  }>(GET_ORDERS);
  const [orderItems, setOrderItems] = useState<OrderConnection>();
  const [isLoading, setIsLoading] = useState<boolean>(loading);

  const handleRefetchOrderItems = async (param: OrderFilterInput) => {
    try {
      const response = await refetch(param);

      if (response) {
        setOrderItems(response.data.order.orders);
        setIsLoading(false);
      }
    } catch (error) {
      errorHandler(error);
    }
  };

  useEffect(() => {
    if (data) {
      setOrderItems(data.order.orders);
    }
  }, [data]);

  useEffect(() => {
    if (myInfo.me) {
      getOrderItems({
        variables: {
          page: 1,
          size: 10,
          filter: {
            hostIds: myInfo.me.host?.id,
            productIds: location.state?.productId
              ? [location.state.productId]
              : null,
            productTitleLike: null,
            customerIds: null,
            itemNameLike: null,
            itemIds: null,
            emailLike: null,
            nameLike: null,
            phoneLike: null,
            itemTypeIn: [ItemType.FRIP, ItemType.DIGITAL],
            orderIds: selectedOrderId ? [selectedOrderId] : null,
            scheduleIds: selectedScheduleIds ? [selectedScheduleIds] : null,
            statusIn: null,
          },
        },
      });

      setTimeout(() => {
        localStorage.removeItem('orderId');
        localStorage.removeItem('scheduleIds');
      }, 1000);
    }
  }, [myInfo]);

  return { orderItems, isLoading, setIsLoading, handleRefetchOrderItems };
}
